import React from 'react'
import PropTypes from 'prop-types'

// Models
import Payment from 'models/Payment'

// Components
import Text from 'ui/Text'

export default function ColumnDateUploadedOR({ row }) {
  if (row.withOR) {
    return (
      <>
        <Text color={row.withORColor}>• Yes</Text>
        <Text paddingLeft={10} size={13} color="#606060">
          {row.orUploadedAt}
        </Text>
      </>
    )
  }

  return <Text color={row.withORColor}>• Not yet</Text>
}

ColumnDateUploadedOR.propTypes = {
  row: PropTypes.instanceOf(Payment),
}

ColumnDateUploadedOR.defaultProps = {
  row: new Payment(),
}
